import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';
import type { Severity } from '../api/types';

interface UseEventsFilters {
  severity?: Severity[] | undefined;
  event_type?: string | undefined;
  job_id?: number | undefined;
  /** ISO 8601 lower bound (inclusive). Phase 3.8 — time-range pills. */
  from?: string | undefined;
  /** ISO 8601 upper bound (exclusive). Phase 3.8 (currently unused). */
  to?: string | undefined;
  limit?: number;
}

/** Poll ``/events`` with the given filters. 5s refresh — matches the
 *  Feed/Status cadence so cross-screen state stays roughly in sync. */
export function useEvents(filters: UseEventsFilters) {
  return useQuery({
    queryKey: ['events', filters],
    queryFn: () => api.listEvents(filters),
    refetchInterval: 5000,
    staleTime: 2000,
  });
}

/** Convenience hook for the DetailScreen timeline — events scoped to
 *  a single job. Cached separately from the global Logs feed so the
 *  two views can use independent pagination later if needed. */
export function useJobEvents(jobId: number | string | undefined) {
  return useQuery({
    queryKey: ['events', { job_id: Number(jobId) }],
    queryFn: () => api.listEvents({ job_id: Number(jobId), limit: 50 }),
    enabled: jobId !== undefined && jobId !== '',
    refetchInterval: 5000,
    staleTime: 2000,
  });
}
